/*
 * @Author:
 * @LastEditTime: 2022-04-18 14:50:56
 * @Description: 后台管理
 */
export default [{
  id: '0e6eda28-7709-46a7-8fce-c50609ea8ffe',
  name: 'double-prevention-management',
  path: '/double-prevention-management-sm',
  meta: {
    title: '双重预防机制'
  },
  children: [{
      id: 'a4f9f867-a711-45c3-93b4-85d8a4a547d4',
      path: 'risk-four-color-chart',
      name: 'risk-four-color-chart',
      component(resolve) {
        require(['./views/RiskFourColorChart'], resolve)
      },
      meta: {
        title: '风险四色图',
        keepAlive: false,
        operations: {},
      },
    },
    {
      id: 'bb9afbc2-a28c-497f-92b0-c3ae9f342954',
      name: 'risk-level',
      path: 'risk-level',
      meta: {
        title: '风险分级管控'
      },
      children: [{
          id: '6eb511ef-4d85-424d-8616-906d2c975d74',
          path: 'risk-statistics',
          name: 'risk-statistics',
          component(resolve) {
            require(['./views/RiskStatistics'], resolve)
          },
          meta: {
            title: '风险统计',
            keepAlive: false,
            operations: {},
          },
        },
        {
          id: '4c915e4c-a707-4529-9510-01b397c50a16',
          path: 'risk-analysis-unit',
          name: 'risk-analysis-unit',
          component(resolve) {
            require(['./views/RiskAnalysisUnit'], resolve)
          },
          meta: {
            title: '风险分析单元',
            keepAlive: false,
            operations: {
              create: {
                id: 0,
                name: 'create',
                desc: '新增',
                access: true,
              },
              delete: {
                id: 1,
                name: 'delete',
                desc: '删除',
                access: true,
              },
              read: {
                id: 2,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              downloadTemplate: {
                id: 3,
                name: 'downloadTemplate',
                desc: '下载模板',
                access: true,
                group: 'read',
              },
              batchImport: {
                id: 4,
                name: 'batchImport',
                desc: '批量导入',
                access: true,
              },
              batchExport: {
                id: 5,
                name: 'batchExport',
                desc: '批量导出',
                access: true,
                group: 'read',
              },
              update: {
                id: 6,
                name: 'update',
                desc: '编辑',
                access: true,
              },
            },
          },
        },
        {
          id: 'f53e2ce1-57bb-4f7d-a5b8-d312439eb5dd',
          path: 'risk-point-list',
          name: 'risk-point-list',
          component(resolve) {
            require(['./views/RiskPointList'], resolve)
          },
          meta: {
            title: '风险点清单',
            keepAlive: false,
            operations: {
              create: {
                id: 0,
                name: 'create',
                desc: '新增',
                access: true,
              },
              delete: {
                id: 1,
                name: 'delete',
                desc: '删除',
                access: true,
              },
              read: {
                id: 2,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              downloadTemplate: {
                id: 3,
                name: 'downloadTemplate',
                desc: '下载模板',
                access: true,
                group: 'read',
              },
              batchImport: {
                id: 4,
                name: 'batchImport',
                desc: '批量导入',
                access: true,
              },
              batchExportQrCode: {
                id: 5,
                name: 'batchExportQrCode',
                desc: '批量导出二维码',
                access: true,
                group: 'read',
              },
              update: {
                id: 6,
                name: 'update',
                desc: '编辑',
                access: true,
              },
              readQrCode: {
                id: 7,
                name: 'readQrCode',
                desc: '二维码',
                access: true,
              },
            },
          },
        },
        {
          id: '1fc9350b-ff7e-4169-91e8-f77be341d93a',
          path: 'risk-identify-plan',
          name: 'risk-identify-plan',
          component(resolve) {
            require(['./views/RiskIdentifyPlan'], resolve)
          },
          meta: {
            title: '危险源辨识计划',
            keepAlive: false,
            operations: {
              create: {
                id: 0,
                name: 'create',
                desc: '新增',
                access: true,
              },
              delete: {
                id: 1,
                name: 'delete',
                desc: '删除',
                access: true,
              },
              read: {
                id: 2,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              downloadTemplate: {
                id: 3,
                name: 'downloadTemplate',
                desc: '下载模板',
                access: true,
                group: 'read',
              },
              batchImport: {
                id: 4,
                name: 'batchImport',
                desc: '批量导入',
                access: true,
              },
              batchExport: {
                id: 5,
                name: 'batchExport',
                desc: '批量导出',
                access: true,
                group: 'read',
              },
              update: {
                id: 6,
                name: 'update',
                desc: '编辑',
                access: true,
              },
              publish: {
                id: 7,
                name: 'publish',
                desc: '发布',
                access: true,
              },
              refreshPublish: {
                id: 8,
                name: 'refreshPublish',
                desc: '重新发布',
                access: true,
              },
            },
          },
        },
        {
          id: '83cc2683-4b93-46a2-b3a5-3457243bd003',
          path: 'risk-identify-list',
          name: 'risk-identify-list',
          component(resolve) {
            require(['./views/RiskIdentifyList'], resolve)
          },
          meta: {
            title: '危险源辨识清单',
            keepAlive: false,
            operations: {
              create: {
                id: 0,
                name: 'create',
                desc: '新增',
                access: true,
              },
              delete: {
                id: 1,
                name: 'delete',
                desc: '删除',
                access: true,
              },
              read: {
                id: 2,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              update: {
                id: 3,
                name: 'update',
                desc: '编辑',
                access: true,
              },
              submit: {
                id: 4,
                name: 'submit',
                desc: '提交',
                access: true,
              },
              identify: {
                id: 5,
                name: 'identify',
                desc: '辨识',
                access: true,
              },
            },
          },
        },
        {
          id: '6d9e1aae-70bf-4daa-83d1-b24e9128042f',
          path: 'risk-evaluate-list',
          name: 'risk-evaluate-list',
          component(resolve) {
            require(['./views/RiskEvaluateList'], resolve)
          },
          meta: {
            title: '风险评估',
            keepAlive: false,
            operations: {
              submit: {
                id: 0,
                name: 'submit',
                desc: '提交',
                access: true,
              },
              update: {
                id: 1,
                name: 'update',
                desc: '编辑',
                access: true,
              },
              read: {
                id: 2,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
            },
          },
        },
        {
          id: 'ee3f1d67-60a7-4555-9c33-7ea309ff2470',
          path: 'risk-grading-control',
          name: 'risk-grading-control',
          component(resolve) {
            require(['./views/RiskGradingControl'], resolve)
          },
          meta: {
            title: '风险分级管控',
            keepAlive: false,
            operations: {
              create: {
                id: 0,
                name: 'create',
                desc: '新增',
                access: true,
              },
              delete: {
                id: 1,
                name: 'delete',
                desc: '删除',
                access: true,
              },
              read: {
                id: 2,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              reject: {
                id: 3,
                name: 'reject',
                desc: '驳回',
                access: true,
              },
              control: {
                id: 4,
                name: 'control',
                desc: '管控',
                access: true,
              },
              submit: {
                id: 5,
                name: 'submit',
                desc: '提交',
                access: true,
              },
            },
          },
        },
        {
          id: 'b4ade100-bcbf-40d6-91eb-380eeda9a6e8',
          path: 'bank-equip-table',
          name: 'bank-equip-table',
          component(resolve) {
            require(['./views/BankEquipTable'], resolve)
          },
          meta: {
            title: '设备设施风险智库',
            keepAlive: false,
            operations: {
              read: {
                id: 0,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              export: {
                id: 1,
                name: 'export',
                desc: '导出',
                access: true,
                group: 'read',
              },
              import: {
                id: 2,
                name: 'import',
                desc: '导入',
                access: true,
              },
              createRiskCard: {
                id: 3,
                name: 'createRiskCard',
                desc: '生产风险应知卡',
                access: true,
              },
              delete: {
                id: 4,
                name: 'delete',
                desc: '删除',
                access: true,
              },
            },
          },
        },
        {
          id: '25d2c387-e07c-4e7a-acd9-6814522afb6f',
          path: 'bank-job-table',
          name: 'bank-job-table',
          component(resolve) {
            require(['./views/BankJobTable'], resolve)
          },
          meta: {
            title: '作业活动风险智库',
            keepAlive: false,
            operations: {
              read: {
                id: 0,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              export: {
                id: 1,
                name: 'export',
                desc: '导出',
                access: true,
                group: 'read',
              },
              import: {
                id: 2,
                name: 'import',
                desc: '导入',
                access: true,
              },
              createRiskCard: {
                id: 3,
                name: 'createRiskCard',
                desc: '生产风险应知卡',
                access: true,
              },
              delete: {
                id: 4,
                name: 'delete',
                desc: '删除',
                access: true,
              },
            },
          },
        },
      ],
    },
    {
      id: '6c9a269a-4360-460c-b76d-bb9a614dd84b',
      name: 'hidden',
      path: 'hidden',
      meta: {
        title: '隐患排查治理'
      },
      children: [
        // {
        //   id: 'e5f0db42-9081-444d-ba86-4e54b9238981',
        //   path: 'troubleshoot-statistics',
        //   name: 'troubleshoot-statistics',
        //   component(resolve) {
        //     require(['./views/TroubleshootStatistics'], resolve)
        //   },
        //   meta: {
        //     title: '隐患排查统计',
        //     keepAlive: false,
        //     operations: {},
        //   },
        // },
        // {
        //   id: 'a8b59f6d-35e5-429e-a65a-7d78ddef2898',
        //   path: 'rectify-trends',
        //   name: 'rectify-trends',
        //   component(resolve) {
        //     require(['./views/RectifyTrends'], resolve)
        //   },
        //   meta: {
        //     title: '隐患整改趋势',
        //     operations: {},
        //   },
        // },
        {
          id: 'f4c45eab-019d-4e47-864b-8fe8d2a193ee',
          path: 'check-list',
          name: 'check-list',
          component(resolve) {
            require(['./views/CheckList'], resolve)
          },
          meta: {
            title: '隐患排查清单',
            operations: {
              create: {
                id: 0,
                name: 'create',
                desc: '新增',
                access: true,
              },
              update: {
                id: 1,
                name: 'update',
                desc: '编辑',
                access: true,
              },
              read: {
                id: 2,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              delete: {
                id: 3,
                name: 'delete',
                desc: '删除',
                access: true,
              },
              export: {
                id: 4,
                name: 'export',
                desc: '批量导出',
                access: true,
                group: 'read',
              },
              batchImport: {
                id: 5,
                name: 'batchImport',
                desc: '批量导入',
                access: true,
              },
              batchExportQrCode: {
                id: 6,
                name: 'batchExportQrCode',
                desc: '批量导出二维码',
                access: true,
                group: 'read',
              },
            },
          },
        },
        {
          id: '17c66c02-e9e9-4adf-ad03-c1cf25481617',
          path: 'task-plan',
          name: 'task-plan',
          component(resolve) {
            require(['./views/TroubleShootTiming'], resolve)
          },
          meta: {
            title: '定时隐患排查',
            operations: {
              create: {
                id: 0,
                name: 'create',
                desc: '新增',
                access: true,
              },
              update: {
                id: 1,
                name: 'update',
                desc: '编辑',
                access: true,
              },
              read: {
                id: 2,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              delete: {
                id: 3,
                name: 'delete',
                desc: '删除',
                access: true,
              },
            },
          },
        },
        {
          id: '20c9effe-2885-4a40-af59-2a1ddcd9186a',
          path: 'check-plan',
          name: 'check-plan',
          component(resolve) {
            require(['./views/CheckPlan'], resolve)
          },
          meta: {
            title: '隐患排查计划',
            operations: {
              create: {
                id: 0,
                name: 'create',
                desc: '新增',
                access: true,
              },
              update: {
                id: 1,
                name: 'update',
                desc: '编辑',
                access: true,
              },
              read: {
                id: 2,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              delete: {
                id: 3,
                name: 'delete',
                desc: '删除',
                access: true,
              },
              export: {
                id: 4,
                name: 'export',
                desc: '导出',
                access: true,
                group: 'read',
              },
              publish: {
                id: 5,
                name: 'publish',
                desc: '发布',
                access: true,
              },
              completionStatus: {
                id: 6,
                name: 'completionStatus',
                desc: '完成情况',
                access: true,
              },
            },
          },
        },
        {
          id: '2623d16e-5ff1-46a9-b1f9-67f6acfe8d53',
          path: 'task',
          name: 'task',
          component(resolve) {
            require(['./views/TroubleShootTask'], resolve)
          },
          meta: {
            title: '隐患排查任务',
            operations: {
              read: {
                id: 0,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
            },
          },
        },
        {
          id: '6d44bd18-9a78-4877-abe0-f7ace33f2b7f',
          path: 'overdue-task',
          name: 'overdue-task',
          component(resolve) {
            require(['./views/TroubleShootOverdueTask'], resolve)
          },
          meta: {
            title: '超期任务',
            operations: {
              read: {
                id: 0,
                name: 'read',
                desc: '查看',
                access: true,

                group: 'read',
              },
            },
          },
        },
        {
          id: '93beee2f-e4ee-402e-848d-1456d8a6deb0',
          path: 'check-records',
          name: 'check-records',
          component(resolve) {
            require(['./views/CheckRecords'], resolve)
          },
          meta: {
            title: '定时排查记录',
            operations: {
              read: {
                id: 1,
                name: 'read',
                desc: '详情',
                access: true,
                group: 'read',
              },
            },
          },
        },
      ],
    },
    {
      id: '765f21c5-c761-4710-80c0-a62d124fcca5',
      name: 'rectification',
      path: 'rectification',
      meta: {
        title: '隐患整改'
      },
      children: [{
          id: '069d62b7-2f79-4590-9319-9c71ffc52fe4',
          path: 'troubleshoot-statistics',
          name: 'troubleshoot-statistics',
          component(resolve) {
            require(['./views/TroubleshootStatistics'], resolve)
          },
          meta: {
            title: '隐患排查统计',
            keepAlive: false,
            operations: {},
          },
        },
        {
          id: 'a48707f9-5fab-4ee4-87fb-56287fa35b62',
          path: 'rectify-trends',
          name: 'rectify-trends',
          component(resolve) {
            require(['./views/RectifyTrends'], resolve)
          },
          meta: {
            title: '隐患整改趋势',
            operations: {},
          },
        },
        {
          id: '6866ef5c-15fb-415f-a870-ade0fe37a894',
          path: 'hidden-list',
          name: 'hidden-list',
          component(resolve) {
            require(['./views/Rectification/HiddenList'], resolve)
          },
          meta: {
            title: '隐患清单',
            operations: {
              create: {
                id: 0,
                name: 'create',
                desc: '新增',
                access: true,
              },
              update: {
                id: 1,
                name: 'update',
                desc: '编辑',
                access: true,
              },
              read: {
                id: 2,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              delete: {
                id: 3,
                name: 'delete',
                desc: '删除',
                access: true,
              },
              export: {
                id: 4,
                name: 'export',
                desc: '导出',
                access: true,
                group: 'read',
              },
              submit: {
                id: 5,
                name: 'submit',
                desc: '提交',
                access: true,
              },
              batchImport: {
                id: 6,
                name: 'batchImport',
                desc: '批量导入',
                access: true,
              },
            },
          },
        },
        {
          id: 'bb7d1943-4dc4-456e-8ed9-dcf4fd90539b',
          path: 'hidden-controls-center',
          name: 'hidden-controls-center',
          component(resolve) {
            require(['./views/Rectification/HiddenControlsCenter'], resolve)
          },
          meta: {
            title: '待办隐患排查控制台',
            hidden: true,
            tabnab: false,
          },
        },
        {
          id: '8c176e9b-314e-450e-84bd-6ac15eeafa6c',
          path: 'hidden-verify',
          name: 'hidden-verify',
          component(resolve) {
            require(['./views/Rectification/HiddenVerify'], resolve)
          },
          meta: {
            title: '隐患审核',
            operations: {
              update: {
                id: 0,
                name: 'update',
                desc: '核实',
                access: true,
              },
              read: {
                id: 1,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
            },
          },
        },
        {
          id: 'd1cd4ef2-1dce-4ef5-8aff-64ad46aaffac',
          path: 'hidden-Rectification',
          name: 'hidden-Rectification',
          component(resolve) {
            require(['./views/Rectification/HiddenRectification'], resolve)
          },
          meta: {
            title: '隐患整改',
            operations: {
              single: {
                id: 0,
                name: 'single',
                desc: '整改单',
                access: true,
              },
              read: {
                id: 1,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              rectification: {
                id: 3,
                name: 'rectification',
                desc: '整改',
                access: true,
              },
              accpet: {
                id: 4,
                name: 'accpet',
                desc: '验收',
                access: true,
              },
              delay: {
                id: 5,
                name: 'delay',
                desc: '延期',
                access: true,
              },
              audit: {
                id: 6,
                name: 'audit',
                desc: '审核',
                access: true,
              },
            },
          },
        },
        {
          id: '758b6e63-7ca2-4507-aaf3-68454530c223',
          path: 'hidden-Accept',
          name: 'hidden-Accept',
          component(resolve) {
            require(['./views/Rectification/HiddenAccept'], resolve)
          },
          meta: {
            title: '隐患验收',
            operations: {
              update: {
                id: 0,
                name: 'update',
                desc: '验收',
                access: true,
              },
              read: {
                id: 1,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              export: {
                id: 2,
                name: 'export',
                desc: '导出',
                access: true,
                group: 'read',
              },
            },
          },
        },
        {
          id: '29efa27c-9c23-49a2-af06-315323711839',
          path: 'hidden-book',
          name: 'hidden-book',
          component(resolve) {
            require(['./views/Rectification/HiddenBook'], resolve)
          },
          meta: {
            title: '隐患台账',
            operations: {
              read: {
                id: 0,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              export: {
                id: 1,
                name: 'export',
                desc: '导出',
                access: true,
                group: 'read',
              },
              batchImport: {
                id: 2,
                name: 'batchImport',
                desc: '批量导入',
                access: true,
              },
              cancel: {
                id: 3,
                name: 'cancel',
                desc: '销号',
                access: true,
              },
              delete: {
                id: 4,
                name: 'delete',
                desc: '删除',
                access: true,
              },
            },
          },
        },
      ],
    },
    {
      id: '63c546bc-6873-4f8e-8c80-220d04b8f84e',
      name: 'auto-check',
      path: 'auto-check',
      meta: {
        title: '自动考核机制'
      },
      children: [{
          id: '26694255-4e4b-44fe-8106-1377a4cb41df1',
          path: 'check-config',
          name: 'check-config',
          component(resolve) {
            require(['./views/AutoCheckConfig'], resolve)
          },
          meta: {
            title: '自动考核配置',
            operations: {
              update: {
                id: 1,
                name: 'update',
                desc: '编辑',
                access: true,
              },
              save: {
                id: 2,
                name: 'save',
                desc: '保存',
                access: true,
              },
            },
          },
        },
        {
          id: '54cf916f-a86f-41e1-987c-8bcde999b340',
          path: 'score-records',
          name: 'score-records',
          component(resolve) {
            require(['./views/ScoreRecords'], resolve)
          },
          meta: {
            title: '积分记录',
            operations: {
              delete: {
                id: 1,
                name: 'delete',
                desc: '删除',
                access: true,
              },
              batchExport: {
                id: 2,
                name: 'batchExport',
                desc: '批量导出',
                access: true,
                group: 'read',
              },
            },
          },
        },
        {
          id: '171e57e5-ae63-454b-9905-f9ba97661ab4',
          path: 'outsource-check',
          name: 'outsource-check',
          component(resolve) {
            require(['./views/OutsourceCheck'], resolve)
          },
          meta: {
            title: '外包外委考核',
            operations: {
              read: {
                id: 0,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              batchExport: {
                id: 2,
                name: 'batchExport',
                desc: '批量导出',
                access: true,
                group: 'read',
              },
            },
          },
        },
        {
          id: '342b57f1-c4fc-495c-b81c-aa4fe56686c2',
          path: 'depart-check',
          name: 'depart-check',
          component(resolve) {
            require(['./views/DepartCheck'], resolve)
          },
          meta: {
            title: '部门考核',
            operations: {
              read: {
                id: 0,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              batchExport: {
                id: 2,
                name: 'batchExport',
                desc: '批量导出',
                access: true,
                group: 'read',
              },
            },
          },
        },
        {
          id: '68d87461-b39d-40e4-9523-d30ea494df6b',
          path: 'person-records',
          name: 'person-records',
          component(resolve) {
            require(['./views/PersonCheck'], resolve)
          },
          meta: {
            title: '人员考核',
            operations: {
              read: {
                id: 0,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              batchExport: {
                id: 2,
                name: 'batchExport',
                desc: '批量导出',
                access: true,
                group: 'read',
              },
            },
          },
        },
      ],
    },
    // 三卡管理
    {
      id: '75685805-d209-47c5-8440-c182078889fd',
      name: 'three-card',
      path: 'three-card',
      meta: {
        title: '三卡管理'
      },
      children: [{
          id: '8e1cabd4-588e-4f34-b0cb-413a90d38f1e',
          path: 'staff-harm',
          name: 'staff-harm',
          component(resolve) {
            require(['./views/ThreeCard/StaffHarm'], resolve)
          },
          meta: {
            title: '员工危害特性应知卡',
            operations: {
              create: {
                id: 1,
                name: 'create',
                desc: '新增',
                access: true,
              },
              read: {
                id: 2,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              update: {
                id: 3,
                name: 'update',
                desc: '编辑',
                access: true,
              },
              delete: {
                id: 4,
                name: 'delete',
                desc: '删除',
                access: true,
              },
              batchImport: {
                id: 5,
                name: 'batchImport',
                desc: '批量导入',
                access: true,
              },
              card: {
                id: 7,
                name: 'card',
                desc: '应知卡',
                access: true,
              },
            },
          },
        },
        {
          id: '9e85edf2-cba2-4ccf-876a-0deb827b779d',
          path: 'deal-methods',
          name: 'deal-methods',
          component(resolve) {
            require(['./views/ThreeCard/DealMethods'], resolve)
          },
          meta: {
            title: '处置方法应急卡',
            operations: {
              create: {
                id: 1,
                name: 'create',
                desc: '新增',
                access: true,
              },
              read: {
                id: 2,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              update: {
                id: 3,
                name: 'update',
                desc: '编辑',
                access: true,
              },
              delete: {
                id: 4,
                name: 'delete',
                desc: '删除',
                access: true,
              },
              card: {
                id: 7,
                name: 'card',
                desc: '应知卡',
                access: true,
              },
            },
          },
        },
        {
          id: '4c9822d0-e0e6-4a05-9b2b-599e3e093264',
          path: 'safey-duty',
          name: 'safey-duty',
          component(resolve) {
            require(['./views/ThreeCard/SafeDuty'], resolve)
          },
          meta: {
            title: '安全职责承诺卡',
            operations: {
              create: {
                id: 1,
                name: 'create',
                desc: '新增',
                access: true,
              },
              read: {
                id: 2,
                name: 'read',
                desc: '查看',
                access: true,
                group: 'read',
              },
              update: {
                id: 3,
                name: 'update',
                desc: '编辑',
                access: true,
              },
              delete: {
                id: 4,
                name: 'delete',
                desc: '删除',
                access: true,
              },
              batchImport: {
                id: 5,
                name: 'batchImport',
                desc: '批量导入',
                access: true,
              },
              card: {
                id: 7,
                name: 'card',
                desc: '承诺卡',
                access: true,
              },
              copy: {
                id: 8,
                name: 'copy',
                desc: '复用',
                access: true,
              },
            },
          },
        },
      ],
    },
  ],
}, ]